import chroma from "chroma-js";
var rgba = function(color, opacityLevel) {
    return chroma(color).alpha(opacityLevel).css();
};
var transitionDurationToNum = function(duration) {
    if (duration.indexOf('ms') > 0) {
        return parseInt(duration, 10);
    }
    if (duration.indexOf('s') > 0) {
        return parseInt(duration, 10) * 1000;
    }
    throw new Error("Invalid transition duration: ".concat(duration));
};
var bezierToArray = function(bezierValue) {
    var start = bezierValue.indexOf('(') + 1;
    return bezierValue.slice(start, -1).split(',').map(function(num) {
        return parseFloat(num);
    });
};
export { rgba, bezierToArray, transitionDurationToNum };
